import React from 'react'
import Style from '../viewSummary.module.css'
import { formatTimestamp, isStale, parseTimestamp, relativeTime } from '../summaryFormat'
const SyncTime = ({ icon, label, value }) => {
    const date = parseTimestamp(value)
    const stale = date ? isStale(date) : false
    return (
        <div className={Style.syncItem}>
            <span className={Style.syncIcon}>
                <i className={icon} aria-hidden="true" />
            </span>
            <div className={Style.syncText}>
                <span className={Style.syncLabel}>{label}</span>
                {date ? (
                    <>
                        <span className={Style.syncValue} title={formatTimestamp(date)}>
                            {relativeTime(date)}
                        </span>
                        <span className={[Style.syncHint, stale ? Style.syncHintStale : ''].join(' ')}>
                            {stale ? <i className="uil-exclamation-triangle" aria-hidden="true" /> : null}
                            {formatTimestamp(date)}
                        </span>
                    </>
                ) : (
                    <>
                        <span className={[Style.syncValue, Style.syncValueMuted].join(' ')}>Not synced yet</span>
                        <span className={Style.syncHint}>No activity recorded</span>
                    </>
                )}
            </div>
        </div>
    )
}

const SyncStatus = ({ lastPull, lastPush }) => (
    <div className={Style.syncStatus}>
        <SyncTime icon="uil-cloud-download" label="Last pull" value={lastPull} />
        <SyncTime icon="uil-cloud-upload" label="Last push" value={lastPush} />
    </div>
)

export default SyncStatus
